import { useQuery } from '@tanstack/react-query';
import { fetchMonthlyRating, fetchTotalRating, fetchWeeklyRating } from '@/lib/community';


export function useUserRatings() {
	const week = useQuery({
		queryKey: ['user_weekly_rating'],
		queryFn: fetchWeeklyRating,
	});

	const month = useQuery({
		queryKey: ['user_monthly_rating'],
		queryFn: fetchMonthlyRating,
	});

	const total = useQuery({
		queryKey: ['user_total_rating'],
		queryFn: fetchTotalRating,
	});

	return { week, month, total };
}

export function useUserWeekRatings() {
	const week = useQuery({
		queryKey: ['user_weekly_rating'],
		queryFn: fetchWeeklyRating,
	});
	return { week };
}